import React from 'react';
import { Mail, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="pt-16 pb-10 px-4 border-t border-[#9E7C47]/30 bg-black">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-16">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img src="/coin_logo.png" alt="AI Wealth Manager" className="h-6 w-6" />
              <span className="font-bold text-xl tracking-tight text-white">AI Wealth Manager</span>
            </div>
            
            <p className="text-white/70 mb-6 max-w-md">
              Democratizing wealth management through artificial intelligence. 
              Our mission is to provide everyone with access to sophisticated 
              financial tools previously reserved for the ultra-wealthy.
            </p>
            
            <div className="flex space-x-4">
              <a href="#" className="text-white/50 hover:text-[#F9F1A9] transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/wealthmanager_online" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-[#F9F1A9] transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/wealthmanager-online" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-[#F9F1A9] transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                  <rect width="4" height="12" x="2" y="9" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about-us" className="text-white/70 hover:text-[#F9F1A9] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-white/70 hover:text-[#F9F1A9] transition-colors">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/top-5-news" className="inline-flex items-center text-white/70 hover:text-[#F9F1A9] transition-colors">
                  Blog <ExternalLink className="ml-1 h-3 w-3" />
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg mb-4">Resources</h3>
            <ul className="space-y-3">
              <li><a href="/coming-soon#features" className="text-white/70 hover:text-[#F9F1A9] transition-colors">Features</a></li>
              <li><a href="/coming-soon#how-it-works" className="text-white/70 hover:text-[#F9F1A9] transition-colors">How It Works</a></li>
              <li>
                <Link to="/privacy-policy" className="text-white/70 hover:text-[#F9F1A9] transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-use" className="text-white/70 hover:text-[#F9F1A9] transition-colors">
                  Terms of Use
                </Link>
              </li>
              {/* <li><a href="#" className="text-white/70 hover:text-[#F9F1A9] transition-colors">Terms of Service</a></li> */}
            </ul>
          </div>
        </div>
        
        <div className="border-t border-[#9E7C47]/30 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/50 text-sm mb-4 md:mb-0">
            © {currentYear} AI Wealth Manager. All rights reserved.
          </p>
          
          <a href="mailto:info@wealthmanager.online" className="text-sm text-white/50 hover:text-[#F9F1A9] transition-colors inline-flex items-center">
            <Mail className="h-4 w-4 mr-2" />
            info@wealthmanager.online
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
